import { Button } from "@/components/ui/button";
import { useModal } from "@/stores/modal";
import { useState } from "react";
import { SpinnerModal } from "@/components/ui/spinner-modal";
import { useNavigate } from "react-router-dom";
import { InputFile } from "@/components/ui/input-file";
import { useSotImportMutation } from "@/queries";
import { validateOrToast } from "@/helpers/validateForm";

const schema = {
  file: { required: true, label: "File" },
};

export default function ImportSOT() {
  const navigate = useNavigate();
  const { close } = useModal();
  const { import: importSot, isLoading } = useSotImportMutation();
  const [data, setData] = useState({});
  const [errorDetails, setErrorDetails] = useState([]);
  const handleSubmit = async () => {
    if (!validateOrToast(data, schema)) return;
    setErrorDetails([]);
    importSot(data, {
      onSuccess: () => {
        navigate("/service-desk/sot/all");
        close();
      },
      onError: (err) => {
        const details = err?.response?.data?.error_details;
        if (Array.isArray(details) && details.length > 0) {
          setErrorDetails(details);
        } else {
          setErrorDetails([
            {
              row: null,
              message:
                err?.response?.data?.message ??
                err?.message ??
                "Something went wrong",
            },
          ]);
        }
      },
    });
  };
  if (!data) return <SpinnerModal label="Getting machines data..." />;
  return (
    <div className="flex flex-col gap-[20px] bg-white rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px] max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <h2 className="font-bold md:w-[500px] text-[24px]">Import SOT</h2>
      <h4>
        <b>1. </b>Before you import, please make your Excel format look like
        this <b>Template</b>.
      </h4>
      <div className="flex gap-2 flex-wrap">
        <a
          download={true}
          href={`${
            import.meta.env.VITE_API_BASE_URL
          }/api/v2/import_example/sot`}
          className="purple-button inline-block"
          target="_blank"
          rel="noreferrer"
        >
          Download Excel Example
        </a>
      </div>
      <h4>
        <b>2. </b>If your format is the same as the <b>Template</b>, please
        upload your Excel file below.
      </h4>
      <InputFile
        label="Upload Your Excel File"
        accept=".xlsx,.xls"
        noPreview={true}
        onChange={async (e) => {
          const file = e.target.files[0];
          setErrorDetails([]);
          setData({
            ...data,
            file: file,
          });
        }}
      />
      {errorDetails.length > 0 && (
        <div className="flex flex-col gap-2 bg-red-50 border border-red-300 rounded-[8px] p-4 max-h-[240px] overflow-y-auto">
          <h4 className="font-bold text-red-600 text-[14px]">
            Import failed. No tickets were imported.
          </h4>
          {errorDetails.map((e, i) => (
            <div key={i} className="text-[13px] text-red-700 leading-snug">
              {e.row ? (
                <b>
                  Row {e.row}
                  {e.wsid ? ` (WSID: ${e.wsid})` : ""}:{" "}
                </b>
              ) : (
                <b>File: </b>
              )}
              {e.message}
            </div>
          ))}
        </div>
      )}
      <div className="flex gap-2 flex-col md:flex-row gap-3 justify-end">
        <Button variant="gray" onClick={close}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} isLoading={isLoading}>
          Submit
        </Button>
      </div>
    </div>
  );
}
